import {
  GoabPageBlock,
  GoabContainer,
  GoabSpacer,
  GoabButtonGroup,
  GoabButton,
  GoabCallout
} from "@abgov/react-components";
import DisplayContent from "../../../MPP-Common-SPA/components/DynamicForm/Forms/DisplayContent";
import { useLogin } from "../../hooks/useLogin";
import { getLoggedOutEndpoint } from "../../../ServiceUtils/auth";
import { NEXT_STEPS_FORM_ID } from "../../../MPP-Common-SPA/utils/globalUtility";
import { useSessionManagement } from "../../../ServiceUtils/useSessionManagement";
import { DynamicFields } from "../../../MPP-Common-SPA/components/DynamicForm/Forms/DynamicFields";
import { tryParse } from "../../../MPP-Common-SPA/utils/globalUtility";
import { getProgramEventNameByCode } from '../../../MPP-Common-SPA/utils/getProgramEventNameByCode';
import { constants } from "../../../MPP-Common-SPA/common/constants/statuses";

const FinalConfirmation = ({
  applicationType,
  user,
  getResourceValue,
  uniqueApplicationCode,
  moveBackToApp,
  getRefData,
  userApplicationData,
  programEvents,
}) => {

  const { handleLogout } = useLogin();

  const { getDynamicForm } = useSessionManagement();
  const form = tryParse(getDynamicForm(NEXT_STEPS_FORM_ID, true)?.template);

  if (form?.fields) {

    const findSupportsCentreClick = () => {
      window.open('https://www.alberta.ca/alberta-supports', "_blank");
    }

    const clickHandlers = {
      "handleLogout": handleLogout,
      "moveBackToApp": moveBackToApp,
      "findSupportsCentreClick": findSupportsCentreClick
    };

    const applicationTypeName = getProgramEventNameByCode(programEvents, applicationType)

    const context = { user, code: userApplicationData?.uniqueApplicationCode, applicationTypeName, ...constants };

    return  (
      <DynamicFields
        children={form.fields}
        getResourceValue={getResourceValue}
        getRefData={getRefData}
        clickHandlers={clickHandlers}
        context={context}>
      </DynamicFields>
    );
  }

  const code = userApplicationData?.uniqueApplicationCode;
  return (
    <GoabPageBlock width="704px">
      <GoabSpacer vSpacing="3xl" />
      <GoabCallout type="success" size="medium">
        {getResourceValue( { key: "RESOURCES@finalConfirmation.applicationSubmitted" })}
      </GoabCallout>
      <h1>
        {getResourceValue({ key: "RESOURCES@finalConfirmation.header" })}
      </h1>
      <GoabSpacer vSpacing="xl" />
      <GoabContainer accent="filled" padding="relaxed">
        <DisplayContent
          content={getResourceValue( { key: "RESOURCES@finalConfirmation.subHeader", params: { code }})}
        ></DisplayContent>
      </GoabContainer>
      <GoabSpacer vSpacing="l" />
      <DisplayContent
        content={getResourceValue({ key: "RESOURCES@finalConfirmation.description"})}
      ></DisplayContent>
      <GoabSpacer vSpacing="2xl" />
      <GoabButtonGroup alignment="start">
        <GoabButton
          type="primary"
          onClick={() => {
            document.location.href = `/application?code=${uniqueApplicationCode}`;
          }}
          testId="final-confirmation-view-application-button"
        >
          {getResourceValue({ key: "RESOURCES@finalConfirmation.viewApplication" })}
        </GoabButton>
        <GoabButton type="tertiary" trailingIcon="open" onClick={() => handleLogout(getLoggedOutEndpoint())}>
                  {getResourceValue({ key: "RESOURCES@global.button.signout" })}
        </GoabButton>
      </GoabButtonGroup>
      <GoabSpacer vSpacing="m" />
      <p className="body-m"><strong>*Please ensure account security by signing out when finished.</strong></p>
      <GoabSpacer vSpacing="4xl" />
    </GoabPageBlock>
  );
};

export default FinalConfirmation;